import React from "react";
import { Box } from "app/components/common";
import { breadCrumbsMbtiScreen } from "app/navigation/breadcrumb/BreadcrumbPaths";
import WebDesktopView from "app/components/common/Web/WebDesktopView";
import HeaderMbti from "./HeaderMbti";
import { ScrollView } from "react-native";
import MbtiSearchInput from "./MbtiSearchInput";

interface Props {
  search: string;
  setSearch: (search: string) => void;
  rows: any[];
}

const WebMbtiList = ({ search, setSearch = search => null, rows }: Props) => {
  return (
    <WebDesktopView breadcrumbsPath={breadCrumbsMbtiScreen}>
      <ScrollView>
        <Box
          paddingHorizontal="xxl"
          paddingVertical="xl"
          borderRadius={8}
          backgroundColor="neutral.white"
        >
          <Box
            display="grid"
            columnGap="sl"
            gridTemplateColumns="1fr 1fr"
            marginBottom="l"
          >
            <HeaderMbti />
            <MbtiSearchInput value={search} setSearch={setSearch} />
          </Box>
          {rows}
        </Box>
      </ScrollView>
    </WebDesktopView>
  );
};

export default WebMbtiList;
